import o from"@mui/material/SvgIcon";import{styled as e}from"@mui/material/styles";const t=e(o)((({theme:o,ownerState:e})=>({fontSize:e.size,fill:"none",...e.color&&{color:o.palette[e.color].main}})));export{t as StyledIcon};
//# sourceMappingURL=styles.js.map
